@if (unit.mappedShortName || !canWritePackagingUnits) {
  <span class="saved-state truncate">
    @if (unit.mappedShortName) {
      <mat-icon class="saved-state__icon">straighten</mat-icon>
      <span class="truncate">
        <strong>{{ unit.mappedShortName }}</strong> &nbsp; ({{ unit.mappedLongName }})
        @if (unit.viaDataSource) {
          <span class="saved-state__tag-datasource">via <b>Datenquelle</b></span>
        }
      </span>
    }
  </span>
  @if (canWritePackagingUnits) {
    <button class="action-button" mat-icon-button (click)="deleteUnitMapping(unit)">
      <mat-icon>{{ unit.viaDataSource ? 'edit' : 'close' }}</mat-icon>
    </button>
  }
} @else {
  <mp-packungseinheiten-selector
    [packagingUnits]="platformPackagungUnits"
    [value]="unit"
    [cache]="assignedUnit"
    (emitChanged)="onUnitChange(unit, $event)"
  />
  <button class="action-button" mat-icon-button (click)="saveUnit(unit)">
    <mat-icon>check</mat-icon>
  </button>
}
